export default __webpack_public_path__ + "static/media/van.3e2d3b52.svg";